import { UserTabs } from './user-tabs.model';

export const userTabsPopulated: UserTabs[] = [
  {
    titleCode: 'dashpivotUsers',
    routerLink: '../dashpivot',
  },
  {
    titleCode: 'sitemateUsers',
    routerLink: '../sitemate',
  },
];
